module.exports = __webpack_public_path__ + "img/step58_a_virtual_agent.618794e0.png";